<template>
    <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="850px">
        <v-card class="elevation-24 rounded-lg">
            <v-card-text>
                <br />
                <v-row justify="center">
                    <v-col cols="12" class="text-body-2 px-4">

                        <div class="text-h6 text-center font-weight-bold mb-1">
                            Informativa sul trattamento dei dati personali
                        </div>
                        <div class="text-subtitle-2 text-center mb-6">
                            (ai sensi del Regolamento UE 2016/679-GDPR)
                        </div>

                        <div class="font-weight-bold mb-1">Titolare del trattamento</div>
                        <p>
                            Il titolare del trattamento dei dati personali è:<br/><br/>
                            LPL Soft S.c.a.r.l.<br/>
                            Via G. Barrio 10 - 87100 - Cosenza (CS)<br/>
                            PIVA: 03709230787<br/>
                            <br/>
                            Responsabile: Luigi De Giacomo<br/>
                            Email di contatto: luigi.degiacomo@gmail.com
                        </p>

                        <div class="font-weight-bold mb-1">Tipologia di dati trattati</div>
                        <p>
                            L'app Talk e il portale talkapp.it trattano esclusivamente i dati personali necessari
                            alla gestione e organizzazione delle attività interne della circoscrizione.
                        </p>
                        <p class="mb-1">I dati trattati possono includere:</p>
                        <ul class="mb-3">
                            <li>nominativo</li>
                            <li>numero di telefono</li>
                            <li>indirizzo email</li>
                            <li>elenco degli schemi posseduti dagli oratori</li>
                        </ul>
                        <p>
                            Non vengono raccolti dati sensibili né dati utilizzati per profilazione o finalità
                            commerciali.
                        </p>

                        <div class="font-weight-bold mb-1">Finalità del trattamento</div>
                        <p class="mb-1">I dati personali sono trattati esclusivamente per le seguenti finalità:</p>
                        <ul class="mb-3">
                            <li>organizzazione e gestione del programma dei discorsi</li>
                            <li>coordinamento tra amministratori, coordinatori e oratori della circoscrizione</li>
                            <li>agevolazione della pianificazione delle attività interne</li>
                        </ul>
                        <p>
                            I dati non vengono utilizzati per scopi promozionali, pubblicitari o di marketing.
                        </p>

                        <div class="font-weight-bold mb-1">Base giuridica del trattamento</div>
                        <p>
                            Il trattamento dei dati personali avviene sulla base del consenso dell'utente, espresso
                            tramite accettazione dell'informativa al primo accesso all'applicazione, ai sensi dell'art. 6
                            par. 1 lett. a del Regolamento UE 2016/679.
                        </p>

                        <div class="font-weight-bold mb-1">Modalità di trattamento e sicurezza dei dati</div>
                        <p>
                            I dati personali sono trattati con strumenti informatici e adottando adeguate misure
                            tecniche e organizzative per garantirne la sicurezza. Il database è protetto tramite sistemi di
                            autenticazione e crittografia. L'accesso ai dati è consentito esclusivamente agli utenti
                            autorizzati tramite credenziali di accesso personali.
                        </p>

                        <div class="font-weight-bold mb-1">Accesso ai dati</div>
                        <p class="mb-1">
                            I dati possono essere consultati esclusivamente dai soggetti autorizzati all'interno
                            della circoscrizione, in particolare:
                        </p>
                        <ul class="mb-2">
                            <li>amministratore della circoscrizione</li>
                            <li>coordinatori dei discorsi</li>
                            <li>assistenti</li>
                            <li>oratori</li>
                        </ul>
                        <p>
                            Ogni utente può accedere esclusivamente ai dati necessari allo svolgimento delle proprie
                            funzioni. L'amministratore di sistema può accedere ai dati esclusivamente per finalità
                            tecniche di manutenzione e funzionamento della piattaforma.
                        </p>

                        <div class="font-weight-bold mb-1">Conservazione dei dati</div>
                        <p>
                            I dati personali sono conservati esclusivamente per il tempo necessario alla gestione
                            delle attività dell'applicazione. Nel momento in cui un utente viene rimosso dall'applicazione
                            o richiede la cancellazione dei propri dati, tutte le informazioni personali associate
                            vengono eliminate definitivamente dal sistema.
                        </p>

                        <div class="font-weight-bold mb-1">Hosting e infrastruttura tecnica</div>
                        <p>
                            I dati sono memorizzati su infrastrutture cloud gestite da MongoDB, con server
                            localizzati nell'Unione Europea (Francoforte - Germania). MongoDB opera come responsabile del
                            trattamento dei dati ai sensi dell'art. 28 del GDPR.
                        </p>

                        <div class="font-weight-bold mb-1">Diritti dell'interessato</div>
                        <p class="mb-1">
                            Gli utenti possono in qualsiasi momento esercitare i diritti previsti dagli articoli
                            15-22 del Regolamento UE 2016/679, tra cui:
                        </p>
                        <ul class="mb-3">
                            <li>diritto di accesso ai dati</li>
                            <li>diritto di rettifica</li>
                            <li>diritto alla cancellazione dei dati</li>
                            <li>diritto alla limitazione del trattamento</li>
                            <li>diritto alla portabilità dei dati</li>
                        </ul>
                        <p>
                            Le richieste possono essere inviate al titolare del trattamento all'indirizzo email:
                            luigi.degiacomo@gmail.com
                        </p>

                        <div class="font-weight-bold mb-1">Cookie</div>
                        <p>
                            Il portale utilizza esclusivamente cookie tecnici necessari al funzionamento del sito e
                            alla memorizzazione di preferenze di visualizzazione (ad esempio modalità chiaro/scuro). Non
                            viene effettuata alcuna attività di profilazione degli utenti.
                        </p>

                        <div class="font-weight-bold mb-1">Costi e pubblicità</div>
                        <p>
                            L'applicazione è gratuita e non prevede alcuna forma di pubblicità o utilizzo dei dati
                            degli utenti per finalità commerciali.
                        </p>

                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <template v-if="consenso">
                    <v-btn color="warning" :loading="loading" @click.stop="$emit('rifiuta')">Rifiuta</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="loading" @click.stop="$emit('accetta')">Accetto</v-btn>
                </template>
                <template v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" @click.stop="$emit('input', false)">Ok</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PrivacyDialog',
    props: {
        value:   { type: Boolean, default: false },
        consenso: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
}
</script>
